import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visible", "duration", "easing", "appear", "mountOnEnter", "unmountOnExit", "as", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"];
import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

var noop = function noop() {};

export var propTypes = {
  duration: PropTypes.number,
  visible: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
};
export default (function (Component) {
  return /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var visible = _ref2.visible,
        duration = _ref2.duration,
        _ref2$easing = _ref2.easing,
        easing = _ref2$easing === void 0 ? 'ease' : _ref2$easing,
        _ref2$appear = _ref2.appear,
        appear = _ref2$appear === void 0 ? true : _ref2$appear,
        _ref2$mountOnEnter = _ref2.mountOnEnter,
        mountOnEnter = _ref2$mountOnEnter === void 0 ? true : _ref2$mountOnEnter,
        _ref2$unmountOnExit = _ref2.unmountOnExit,
        unmountOnExit = _ref2$unmountOnExit === void 0 ? true : _ref2$unmountOnExit,
        _ref2$as = _ref2.as,
        as = _ref2$as === void 0 ? 'div' : _ref2$as,
        _ref2$onEnter = _ref2.onEnter,
        onEnter = _ref2$onEnter === void 0 ? noop : _ref2$onEnter,
        _ref2$onEntering = _ref2.onEntering,
        onEntering = _ref2$onEntering === void 0 ? noop : _ref2$onEntering,
        _ref2$onEntered = _ref2.onEntered,
        onEntered = _ref2$onEntered === void 0 ? noop : _ref2$onEntered,
        _ref2$onExit = _ref2.onExit,
        onExit = _ref2$onExit === void 0 ? noop : _ref2$onExit,
        _ref2$onExiting = _ref2.onExiting,
        onExiting = _ref2$onExiting === void 0 ? noop : _ref2$onExiting,
        _ref2$onExited = _ref2.onExited,
        onExited = _ref2$onExited === void 0 ? noop : _ref2$onExited,
        props = _objectWithoutProperties(_ref2, _excluded);

    var _ref = useRef(null);

    var componentRef = ref ? ref : _ref;
    return /*#__PURE__*/React.createElement(Transition, {
      appear: appear,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit,
      "in": visible,
      timeout: duration
    }, function (state) {
      if (componentRef.current) {
        // Line below very important for us. It triggers reflow process.
        // Provide an ability to make transitions for non-mounted yet elements

        /* eslint-disable no-unused-expressions */
        componentRef.current.offsetWidth;
      }

      return /*#__PURE__*/React.createElement(Component, _extends({
        ref: componentRef,
        as: as,
        state: state,
        easing: easing,
        duration: duration
      }, props));
    });
  });
});